module.exports = __webpack_public_path__ + "img/add-departure-requested-climbing-table-icon.6ff889c3.svg";